<template>
    <div class="CSChatThai">

<div style="background: #2562af !important; padding-bottom: 10px ;">
<div id="myModalImage" class="modalc">
          <div id="headcaption">
            <v-container>
              <v-layout row wrap>
                <v-flex xs12 md12 sm12 style="text-align: right;     padding: 30px 10px 5px 20px;">
                  <span class="close" style="cursor: pointer;" @click="closemodal()">&times;</span>
                </v-flex>
              </v-layout>
          </v-container>
          </div>
          <img class="modal-contentc" id="img01">
      </div>



      <div id="myModalNote" class="modalc">
          <div id="headcaption">
            <v-container>
              <v-layout row wrap>
                <v-flex xs6 md6 sm6 style="text-align: left;     padding: 30px 10px 5px 20px;">
                  <span class="close" @click="closemodalnote()" style="cursor: pointer;font-size: 15px;">&times;</span>
                </v-flex>
                <v-flex xs6 md6 sm6 style="text-align: right;">
                  <span @click="create_note()">ยืนยัน</span>
                </v-flex>
              </v-layout>
          </v-container>
          </div>
          <div style="background: white !important; height: 100%; overflow: scroll; padding: 10px;">
            <!-- aslkljjksajsdlkdkdklakksdkjld -->
            <v-textarea
            outlined
            name="input-7-4"
            rows="23"
            placeholder="แชร์โน๊ตในห้องสนทนา"
            v-model="note_data"
          ></v-textarea>
          </div>

      </div>







  <v-btn icon @click="gotopath('/list_room')" style="margin: 0 !important;" :disabled="stateChat!='chat'">
        <v-icon class="white--text">chevron_left</v-icon>
      </v-btn>
 <v-avatar size="35" class=" profileBG" v-if="roomDetail_SepType.room.room_type === 'user'">

    <img :src="backend + roomDetail_SepType.user.profile_picture" class="alligator-turtle" v-if="roomDetail_SepType.user.profile_picture" />
    <span class="headline" v-else> 
      {{(roomDetail_SepType.user.display_name.length>=2)? roomDetail_SepType.user.display_name.charAt(0)+roomDetail_SepType.user.display_name.charAt(1):roomDetail_SepType.user.display_name.charAt(0)}}</span>

  </v-avatar>


   <v-avatar size="35" class="profileBG" v-else-if="roomDetail_SepType.room.room_type === 'group'">
    <img :src="my_picture_Group" class="alligator-turtle" v-if="my_picture_Group" />
      <span class="headline" v-else>{{(roomDetail_SepType.room.room_name.length>=2)? roomDetail_SepType.room.room_name.charAt(0)+roomDetail_SepType.room.room_name.charAt(1):roomDetail_SepType.room.room_name.charAt(0)}}</span>
  </v-avatar>


      <!-- <div style="width: 90%;white-space: break-spaces;overflow: hidden;" v-if="roomDetail_SepType.room.room_type === 'user'">  -->
        <div class="white--text" style="font-weight: 600;    white-space: nowrap;
    width: 54vw;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;" v-if="roomDetail_SepType.room.room_type === 'user'">{{(roomDetail_SepType.user.display_name)? roomDetail_SepType.user.display_name:roomDetail_SepType.user.username}}</div>
      <!-- </div> -->

       <div class="white--text" style="font-weight: 600;    white-space: nowrap;
    width: 54vw;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    vertical-align: middle;" v-else-if="roomDetail_SepType.room.room_type === 'group'">{{roomDetail_SepType.room.room_name}} ({{countgroupMember(roomDetail[0]).length}})</div>

      <v-btn icon @click="switchState()" style="margin: 0 !important;right: 5px;float: right;">
        <v-icon class="white--text" v-if="stateChat=='chat'">mdi-menu</v-icon>
        <v-icon class="white--text" v-else-if="stateChat=='menu'">clear</v-icon>
      </v-btn>

       <br>
</div>

<div v-if="stateChat=='menu'">

  <div class="MenuStyle">
  <v-layout row wrap>
    <v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;" @click="stateMenu='image'">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" :class="(stateMenu=='image')? 'iconMenuHeaderSelected':'iconMenuHeader'" >fas fa-images</v-icon>
      </template>
      <span>รูปภาพ</span>
      </v-tooltip>
    </v-flex>

    <v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;" @click="stateMenu='file'">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" :class="(stateMenu=='file')? 'iconMenuHeaderSelected':'iconMenuHeader'">fas fa-file-alt</v-icon>
        </template>
        <span>ไฟล์</span>
      </v-tooltip>
    </v-flex>

<!--     <v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;" @click="stateMenu='note'">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" :class="(stateMenu=='note')? 'iconMenuHeaderSelected':'iconMenuHeader'">far fa-sticky-note</v-icon>
        </template>
        <span>โน๊ต</span>
      </v-tooltip>
    </v-flex>
 -->
<v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;" @click="stateMenu='detail'" v-if="roomDetail_SepType.room.room_type === 'group'">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" class="iconMenuHeader" :class="(stateMenu=='detail')? 'iconMenuHeaderSelected':'iconMenuHeader'">fas fa-users-cog</v-icon>
    </template>
      <span>ข้อมูลกลุ่ม</span>
      </v-tooltip>
    </v-flex>


    <v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;" @click="leaveGroup()" v-if="roomDetail_SepType.room.room_type === 'group'">
      <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" class="iconMenuHeader">fas fa-sign-out-alt</v-icon>
    </template>
      <span>ออกจากกลุ่ม</span>
      </v-tooltip>
    </v-flex>

    <v-flex xs2 xl2 lg2 md2 sm2 style="text-align: center;" @click="stateMenu='detailuser'" v-if="roomDetail_SepType.room.room_type === 'user'">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" class="iconMenuHeader" :class="(stateMenu=='detailuser')? 'iconMenuHeaderSelected':'iconMenuHeader'">fas fa-users-cog</v-icon>
    </template>
      <span>ข้อมูลเพื่อน</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
  </div>

  <div v-if="stateMenu=='image'" style="height: 70vh; overflow: scroll;">
    <v-layout row wrap v-if="listImage.length">
      <v-flex v-for="file in listImage" xs4 d-flex >
        <v-card flat tile class="d-flex" style="cursor: pointer; padding: 3px;">
          <v-img :src="backend + file.message_data.url" aspect-ratio="1" class="grey lighten-2 alligator-turtle" @click="zoom(file)" >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0 >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <div v-else style="margin-top: 20px;text-align: center;">
      ไม่พบการส่งภาพในห้องสนทนานี้
    </div>
  </div>
  <div v-else-if="stateMenu=='file'" style="height: 70vh; overflow: scroll;">
    <v-layout row wrap v-if="listFile.length">
          <v-list two-line dense style="width: 100%;" v-for="(file, index) in listFile">
            <v-list-tile>
              <v-list-tile-avatar>
                <v-icon style="color: #1da1f2;" large>{{extension(file.message_data.url)}}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title style="color: #2562af !important;font-weight: 600; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;">
                  <span>{{file.message_data.file_name}}</span>
                  <p>{{file.message_data.file_name}}</p>
                </v-list-tile-title>
                <v-list-tile-sub-title class="CSChatThai">
                  <p style="font-size: 9px;color: #1010106b;">{{dateMoment(file.create_at)}} - {{timeMoment(file.create_at)}}</p>
                  <v-btn depressed small class="btnallow" :href="backend + file.message_data.url" target="_blank">
                    ดาวน์โหลด
                  </v-btn>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider v-if="index != listFile.length-1"></v-divider>
          </v-list>
    </v-layout>
    <div v-else style="margin-top: 20px;text-align: center;">
      ไม่พบการส่งไฟล์ในห้องสนทนานี้
    </div>
  </div>

  <div v-else-if="stateMenu=='note'" style="height: 70vh; overflow: scroll;">
    <div v-if="listNote.length" style="text-align: right;">
    <v-layout row wrap style="text-align: center;">
           <v-layout row wrap v-for="(note, index) in listNote" @click="openNote_byid(note.note_id)">
      <v-flex xs2 xl2 lg2 md2 sm2 style="padding: 15px 0px;display: flex;
    justify-content: center;">
        <v-avatar size="35" class="profileBG" >
    <img :src="backend + note.user_created.profile_picture" class="alligator-turtle" v-if="note.user_created.profile_picture" />
      <span class="headline" v-else>
        {{(note.user_created.display_name.length>=2)? note.user_created.display_name.charAt(0)+note.user_created.display_name.charAt(1):note.user_created.display_name.charAt(0)}}</span>
  </v-avatar>
      </v-flex>
       <v-flex xs10 xl10 lg10 md10 sm10 style="padding: 10px 10px 2px  0px;     text-align: left;">
        <!-- {{note.note_id}} -->
        <span style="color: #2562af !important;font-weight: 600; white-space: nowrap;width: 15em; overflow: hidden; text-overflow: ellipsis;">{{note.user_created.display_name}}</span>

 <div v-html="convert(note.note_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')" style="width: 75vw;
    white-space: break-spaces;overflow: hidden;"></div>
        <p style="font-size: 9px;color: #1010106b; margin-top: 10px;">{{dateMoment(note.create_at)}} - {{timeMoment(note.create_at)}}</p>
      </v-flex>
      <v-flex xs12 xl12 lg12 md12 sm12 >
      <v-divider></v-divider>
    </v-flex>
    </v-layout>
    </v-layout>
    <!-- <div style="text-align: right;width: 100vw;"> -->
    <v-btn
                    v-show="createbuttonnote_show"
                    style="background: #2663af !important;    bottom: 10px;right: 20px;"
                    fab
                    dark
                    small
                    absolute
                    bottom
                    rigth
                    @click="openCreateNote"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
  <!-- </div> -->
    <div v-else style="margin-top: 20px;text-align: center;">
      ไม่พบการส่งโน๊ตในห้องสนทนานี้
      <v-btn
                    v-show="createbuttonnote_show"
                    style="background: #2663af !important;    bottom: 10px;right: 20px;"
                    fab
                    dark
                    small
                    absolute
                    bottom
                    rigth
                    @click="openCreateNote"

                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
    </div>
  </div>





  <div v-else-if="stateMenu=='detail'">
    <v-layout row wrap style="margin-top: 20px; padding: 10px;">
      <v-flex xs12 xl12 lg12 md12 sm12>
        <div style="display: flex;justify-content: center;">
          <div class="image-upload">
            <v-img :src="my_picture_Group" aspect-ratio="1" class="grey lighten-2 imageProfile alligator-turtle" @click="uppic" v-if="my_picture_Group" >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0 >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <v-img src="/static/img/default_profile/group-white.png" aspect-ratio="1" class="grey lighten-2 imageProfile alligator-turtle" @click="uppic" v-else >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center  ma-0 >
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
            <label for="file-input" class="SettingImgBtn">
              เปลี่ยนรูป
            </label>
            <input id="file-input" type="file" @change="previewImageGroup" accept="image/*"/>
          </div>
        </div>
        <div style="margin-top: 10px;">
          <div class="detailBG" @click="dialogGroupName=true">
            <p class="HeadersDetail">ชื่อกลุ่ม</p>
            <p class="Detail">{{groupname}} </p>
          </div>
          <div class="detailBG" @click="showdetail_memberGroup()" >
            <p class="HeadersDetail">สมาชิก ({{countgroupMember(roomDetail[0]).length}})</p>
            <v-avatar size="30" class="profileBG_White " v-for="item in countgroupMember(roomDetail[0])" style="margin-right: -10px;">
              <v-img :src="backend + item.user.profile_picture" aspect-ratio="1" class="grey lighten-2 alligator-turtle" v-if="item.user.profile_picture" />
              <span class="headline " v-else>
                {{(item.user['display_name'].length>=2)? item.user['display_name'].charAt(0)+item.user['display_name'].charAt(1):item.user['display_name'].charAt(0)}}

              <!-- {{item.user.display_name.charAt(0)}} -->
            </span>
            </v-avatar>
          </div>
           <div style="display: flex; justify-content: center;">
            <!-- <p  @click="showdetail_memberGroup()">จัดการสมาชิก</p> -->
            <v-btn class="btnSave" small @click="showdetail_memberGroup()">จัดการสมาชิก</v-btn>
          </div>

        </div>
      </v-flex>
    </v-layout>
  </div>

   <div v-else-if="stateMenu=='detailuser'">
    <v-layout row wrap style="margin-top: 20px; padding: 10px;">
  <v-flex xs12 xl12 lg12 md12 sm12>
    <div style="display: flex;justify-content: center;">
      <div class="image-upload">
    <v-img
            :src="my_picture_Group"
            aspect-ratio="1"
            class="grey lighten-2 imageProfile alligator-turtle"
            v-if="my_picture_Group"
            />

          <v-img
            src="/static/img/default_profile/man-white.png"
            aspect-ratio="1"
            class="grey lighten-2 imageProfile alligator-turtle"
            v-else
            />
   
</div>
      </div>
      <div style="margin: 20px;">
<div >
<p class="HeadersDetail">ชื่อแสดง</p>
<p class="Detail">{{roomDetail_SepType.user.display_name}} </p>
</div>
<div style="margin-top: 20px;">
<p class="HeadersDetail">อีเมล</p>
<p class="Detail">{{roomDetail_SepType.user.email}} </p>
</div>
</div>
    </v-flex>
  </v-layout>
  </div>
</div>





<div v-else-if="stateChat=='chat'">
  <div style="height: auto;background: #61616126;position: fixed;
    width: 100%;" v-if="roomDetail_SepType.status=='pending'">
    <p style="padding-top: 2px !important; text-align: center;">คุณได้รับคำเชิญเข้ากลุ่ม</p>
    <div style="text-align: center;">
      <v-btn small class="cancelGroup" @click="cancelGroup()">ปฏิเสธ</v-btn>
      <v-btn small class="acceptGroup" @click="acceptGroup()">ยืนยัน</v-btn>
    </div>
  </div>
<div >




<div class="chat-container" @scroll="onScroll" ref="chatContainer" :style="scrollable" v-if="roomDetail_SepType.status !=='pending'">
  
        <vue-context ref="vueSimpleContextMenu" style="z-index: 1500;" class="menuContext">
              <span v-for="(list,index) in ListMenuRightClick" @click="SelectMenuRightClick(list.methods, list.detail)" :class="(index !== ListMenuRightClick.length-1)? 'MenuRightSelect': 'MenuRightSelect Last'">{{list.message}}</span>
        </vue-context>
         



            <div class="message" v-for="(msg,index) in message" :key="index" :class="{own: msg.user_send.user_id == user_id}" :id="msg.message_id" >
              <!-- {{msg['get_read_in_room']}} -->
<!-- {{msg.user_send.user_id != user_id}} -->

                <div class="systemDateNonMGT CSChatThai" style="text-align: center;" v-if="index == 0">
                  <span>{{dateMoment(msg.create_at)}}</span>
                </div>
                <div class="systemDate CSChatThai" style="text-align: center;" v-else-if="dateMoment(message[index-1].create_at) != dateMoment(msg.create_at)">
                  <span>{{dateMoment(msg.create_at)}}</span>
                </div>





                <div class="systemMSG2 CSChatThai" v-if="msg.message_type == 'system'" style="text-align: center;">
                  <p>{{timeMoment(msg.create_at)}}  </p>
                  <p v-if="msg.message_data.verb === 'joined_group'"> {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} เข้าร่วมกลุ่ม</p>

                  <p v-else-if="msg.message_data.verb === 'invited_to_group'"> 
                    <Promised :promise="GetDisplayUser(msg.message_data.object)">
                  <template v-slot:pending>
                    <p>Loading...</p>
                  </template>
                  <template v-slot="data">
                  {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} เชิญ {{data}} ให้เข้าร่วมกลุ่ม
                  </template>
                </Promised>
                </p>

                  <p v-else-if="msg.message_data.verb === 'remove_from_group'"> 

                    <Promised :promise="GetDisplayUser([msg.message_data.object])">
                  <template v-slot:pending>
                    <p>Loading...</p>
                  </template>
                  <template v-slot="data">
                  {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} ลบ {{data}} ออกจากกลุ่ม
                  </template>
                </Promised>




         <!--            {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} ลบ {{msg.message_data.object.display_name}} ออกจากกลุ่ม
                    {{msg.message_data.object}} -->


                  </p>

                  <p v-else-if="msg.message_data.verb === 'remove_pending_from_group'"> 

             <!--      {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} ยกเลิกการเชิญ {{msg.message_data.object.display_name}} เข้ากลุ่ม -->

                    <Promised :promise="GetDisplayUser([msg.message_data.object])">
                  <template v-slot:pending>
                    <p>Loading...</p>
                  </template>
                  <template v-slot="data">
                  {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} ยกเลิกการเชิญ {{data}} เข้ากลุ่ม
                  </template>
                </Promised>

                </p>



                  <p v-else-if="msg.message_data.verb === 'left_group'"> {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} ออกจากกลุ่ม</p>
                  <p v-else-if="msg.message_data.verb === 'change_group_name'"> {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} เปลี่ยนชื่อกลุ่มเป็น "{{msg.message_data.object}}"</p>
                  <p v-else-if="msg.message_data.verb === 'change_group_picture'"> {{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} เปลี่ยนรูปโปรไฟล์กลุ่ม</p>
                </div>




              <div v-else-if="(msg.user_send.user_id != user_id) && msg.message_type !== 'unsent_message'">
            <div v-if="index == 0">
              <div class="username CSChatThai" >
              <v-avatar size="35" class="profileBG_White" @click="getdetailUser_who(msg.user_send)">
                <v-img
            :src="backend + msg.user_send.profile_picture"
            v-if="msg.user_send.profile_picture"
            aspect-ratio="1"
            class="grey lighten-2 alligator-turtle"
          >
            <template v-slot:placeholder>
              <v-layout
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
                <span class="headline " v-else>
                  {{(msg.user_send.display_name.length>=2)? msg.user_send.display_name.charAt(0)+msg.user_send.display_name.charAt(1):msg.user_send.display_name.charAt(0)}}</span>
              </v-avatar>



              {{msg.user_send.display_name}}
            </div>
            </div>


            <div v-else-if="(message[index-1].user_send.user_id != msg.user_send.user_id) || (dateMoment(message[index-1].create_at) != dateMoment(msg.create_at)) || (message[index-1].message_type == 'unsent_message' && msg.message_type !== 'unsent_message') || (message[index-1].message_type == 'system' && msg.message_type !== 'system')">
              <div class="username CSChatThai" >

              <v-avatar size="35" class="profileBG_White" @click="getdetailUser_who(msg.user_send)">
                <v-img
            :src="backend + msg.user_send.profile_picture"
            v-if="msg.user_send.profile_picture"
            aspect-ratio="1"
            class="grey lighten-2 alligator-turtle"
          >
            <template v-slot:placeholder>
              <v-layout
                fill-height
                align-center
                justify-center
                ma-0
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
                <span class="headline " v-else>
                  {{(msg.user_send.display_name.length>=2)? msg.user_send.display_name.charAt(0)+msg.user_send.display_name.charAt(1):msg.user_send.display_name.charAt(0)}}</span>
              </v-avatar>


            {{msg.user_send.display_name}}
          </div>
          </div>

          </div>

            <span v-else-if="msg.user_send.user_id == user_id && msg.message_type !== 'unsent_message'" class="pr-2" style="font-size: 9px; color: #424242b3;display: inline-block;"> 
          <!--     {{index}}
              {{message.length-1}}
              {{msg.get_read_in_room.length}}
              {{msg[index+1].get_read_in_room.length}}    -->           
              <span v-if="(msg.get_read_in_room && msg.get_read_in_room.length != 0)" >
                อ่านแล้ว 
                <span v-if="roomDetail_SepType.room.room_type === 'group'">{{msg.get_read_in_room.length}} คน </span>
                <br/>
              </span> 
              {{timeMoment(msg.create_at)}}
            </span>

            <div class="systemMSG CSChatThai" v-if="msg.message_type == 'unsent_message'" style="text-align: center;">

                  <span>{{(msg.user_send.user_id == user_id) ? 'คุณ':msg.user_send.display_name + ' '}} ยกเลิกข้อความแล้ว</span>
                </div>


                <div class="content CSChatThai" v-else-if="msg.message_type == 'text'" @contextmenu.prevent="RightClickDialog($event,['reply','cancel'], msg)">
                  <!-- {{msg}} -->

                    <div v-html="convert(msg.message_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')" ></div>

                    <div v-for="x in convertURL(msg.message_data.text)" v-if="convertURL(msg.message_data.text)">
              <link-prevue :url="x">
                <template slot-scope="props">
                  <!-- {{props}} -->
                  <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                    <v-flex xs9 xl9 lg9 md9 sm9 class="border_website">
                      <p class="title_website" >{{props.title}}</p>
                      <span class="description_website">{{props.description}}</span>
                    </v-flex>
                    <v-flex xs3 xl3 lg3 md3 sm3 class="centerimg_website">
                      <img class="img_website" :src="props.img"  v-if="props.img">
                    </v-flex>
                  </v-layout>
                </template>
                <template slot="loading">
                  <span></span>
                </template>
              </link-prevue>
            </div>
                </div>


               <!--   <div class="content CSChatThai" v-else-if="msg.message_type == 'note'" @contextmenu.prevent="RightClickDialog($event,['reply', 'cancel'], msg)" @click="openNote_byid(msg.message_data.note_id)">
                    <div v-html="convert(msg.message_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')" ></div>

                </div> -->

                <p slot="activator" v-else-if="msg.message_type === 'note'" style="cursor: pointer;" class="contentNote CSChatThai" @click="openNote_byid(msg.message_data.note_id)">
                <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%; box-shadow: none;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <p style="color: black;" v-html="convert(msg.message_data.text).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                      <p v-if="msg.message_data.text.length == 20"> ...</p>
                    </v-flex>
                  </v-layout>
                  <v-divider light style="border-color: #31394121 !important;"></v-divider>
                  <v-card-actions style="padding-left: 0px !important;">
                    <span style=" color: #4c6281 !important; "> โน๊ต </span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #4c6281 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>








                <img  :src="backend + msg.message_data.url" style="max-height: 150px;max-width: 60vw;border-radius: 10px;cursor: pointer;" class="contentimage"  v-else-if="msg.message_type == 'image'" @click="zoom(msg)" @contextmenu.prevent="RightClickDialog($event,['reply','cancel'], msg)">

                <div class="contentfile CSChatThai"  v-else-if="msg.message_type == 'file' && extension(msg.message_data.url) === 'fas fa-file-alt'" @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)">
                  <pdf :src="backend + msg.message_data.url" :page="1"></pdf>
                  <p class="wrap" style="font-size: 12px; text-align: left;font-weight: 600;margin-top: 5px;">{{msg.message_data.file_name}}</p>
                  <div style="margin-top: 10px;" >
                    <span class="textDownload" @click="downloadFile(msg.message_data)">ดาวน์โหลด</span>
                    |
                    <span class="textDownload" @click="openFilePDF(msg.message_data)">แสดง</span>
                  </div>
                </div>
                <div class="contentfile CSChatThai"  v-else-if="msg.message_type == 'file'" @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)">
                  <v-layout >
                    <v-flex xs3 xl3 md3 sm3 lg3>
                      <v-icon class="iconFile">{{extension(msg.message_data.url)}}</v-icon>
                    </v-flex>
                    <v-flex xs9 xl9 md9 sm9 lg9>
                      <p class="wrap" style="font-size: 12px; text-align: left; border-left: 1px solid white; padding-left: 5px;margin-bottom: 10px !important;">{{msg.message_data.file_name}}</p>
                      <span class="textDownload"  @click="downloadFile(msg.message_data)">ดาวน์โหลด</span>
                    </v-flex>
                  </v-layout>
                </div>

                <video  controls style="border-radius: 10px;justify-content: center; align-items: center;max-height: 150px;max-width: 60vw;" v-else-if="msg.message_type == 'video'" class="contentvideo" @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)">
                  <source :src="backend + msg.message_data.url" :type="'video/' + msg.message_data.url.split('.')[msg.message_data.url.split('.').length - 1]">
                </video>

                <audio controls style=" border-radius: 10px; width: 60vw;height: 30px;" v-else-if="msg.message_type == 'audio'" @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)">
                  <source :src="backend + msg.message_data.url" :type="'audio/' + msg.message_data.url.split('.')[msg.message_data.url.split('.').length - 1]">
                </audio>




                <div v-else-if="msg.message_type == 'reply_text'" class="content CSChatThai" style="width: 75% !important;" @contextmenu.prevent="RightClickDialog($event,['reply', 'cancel'], msg)">
                    <v-layout row wrap style="padding-bottom: 10px;" >
                  <v-flex xs3 xl3 md3 sm3 lg3 v-if="msg.message_data.message_data_reply.message_type!=='unsent_message'">
                    <v-avatar size="25" class="profileBG_White" >
                <v-img
            :src="backend + msg.message_data.message_data_reply.user_send.profile_picture"
            v-if="msg.message_data.message_data_reply.user_send.profile_picture"
            aspect-ratio="1"
            class="grey lighten-2 alligator-turtle"
          >
          </v-img>
                <span class="headline " v-else>
                  {{(msg.message_data.message_data_reply.user_send.display_name.length>=2)? msg.message_data.message_data_reply.user_send.display_name.charAt(0)+msg.message_data.message_data_reply.user_send.display_name.charAt(1):msg.message_data.message_data_reply.user_send.display_name.charAt(0)}}</span>
              </v-avatar>
                  </v-flex>
                  <v-flex xs9 xl9 md9 sm9 lg9 style="">

                    <div style="display: inline-block;" v-if="msg.message_data.message_data_reply.message_type !== 'unsent_message'">
                    <p style="font-weight: 600;">{{msg.message_data.message_data_reply.user_send.display_name}}</p>
       
                    <p v-if="msg.message_data.message_data_reply.message_type=='text' || msg.message_data.message_data_reply.message_type=='reply_text'">{{msg.message_data.message_data_reply.message_data.text}}</p>
                    <p v-else-if="msg.message_data.message_data_reply.message_type=='image'">รูป</p>
                    <p v-else style="color: #35353594 !important;"> ไม่สามารถรองรับในเวอร์ชันนี้</p>
                  </div>
                    <p v-if="msg.message_data.message_data_reply.message_type == 'unsent_message'" style="color: #35353594 !important;"> ไม่สามารถแสดงข้อความนี้ได้</p>
                    <img  :src="backend + msg.message_data.message_data_reply.message_data.url" style="float:right;display: inline-block;max-height: 40px;max-width: 20vw;border-radius: 10px;cursor: pointer;" class="contentimage"  v-else-if="msg.message_data.message_data_reply.message_type == 'image'" >

                    
                  </v-flex>
                </v-layout>
                  <v-divider></v-divider>
                  <span>
                  {{msg.message_data.text}}</span>
                </div>


               <!--  <div v-else-if="msg.message_type == 'reply_unsent_text'" class="content CSChatThai" style="width: 75% !important;" @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)">
                  <template >
                    <v-layout row wrap style="padding-bottom: 10px;" >
                  <v-flex xs9 xl9 md9 sm9 lg9 style="">
                    <p style="color: #35353594 !important;"> ไม่สามารถแสดงข้อความนี้ได้</p>
                  </v-flex>
                </v-layout>
                  </template>
                  <v-divider></v-divider>
                  <span>{{msg.message_data.text}}</span>
                </div> -->





<div v-else-if="msg.message_type == 'video_m3u8'" @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)" class="CSChatThai" style="    display: inline-block;">
<vplayer :playerOptions="{
        type: 'application/x-mpegURL',//媒体类型，m3u8请给application/x-mpegURL或者application/vnd.apple.mpegURL，其他的会默认为普通音视频，注：微信不支持m3u8
        src: backend + msg.message_data.url,//视频地址
        preload: true,//是否预下载，默认为true
        autoplay: false,//是否自动播放（兼容性不太好），默认为false
        isLoop: false,//是否循环，默认不循环
        playsinline: false, //h5是否行内播放，默认false，有兼容性问题
        poster: backend + msg.message_data.thumbnail,
        controls: 'progress,current,durration,volume', //显示的控件,volume只有视频有，没有配置controls项则全部显示。
        crossOrigin: false //设置视频的 CORS 设置。
      }" 
      class="contentvideo" 
      
      />
    </div>


    <!--   <video preload="true" :poster="backend + msg.message_data.thumbnail" :src="backend + msg.message_data.url" controls @contextmenu.prevent="RightClickDialog($event,['cancel'], msg)" v-else-if="msg.message_type == 'video_m3u8'" }" v-else-if="msg.message_type == 'video_m3u8'" 
      class="contentvideo" ></video> -->

<!-- <video  controls style="border-radius: 10px;justify-content: center; align-items: center;max-height: 150px;max-width: 60vw;" v-else-if="msg.message_type == 'video_m3u8'" class="contentvideo">
                  <source :src="backend + msg.message_data.url" :type="'video/' + msg.message_data.url.split('.')[msg.message_data.url.split('.').length - 1]">
                </video> -->



                 <div class="contentnot_support CSChatThai" style="margin-top: 5px;" v-else-if="msg.message_type !== 'system'&& msg.message_type !== 'unsent_message'" >
                   <span style=""> ข้อความประเภทนี้ยังไม่รองรับในเวอร์ชันนี้ </span>
                </div>












                <span class="pr-2" style="font-size: 10px; color: #424242b3;" v-if="msg.user_send.user_id != user_id && msg.message_type !== 'unsent_message' && msg.message_type !== 'system'">{{timeMoment(msg.create_at)}}</span>

            </div>


        </div>
</div>




<v-flex lg12 md12 sm12 xl12 class="showmentionCSS" v-if="showmention">
      <v-layout row wrap>
        <v-flex xs2 xl2 md2 sm2 lg2>
          <v-avatar size="35" class="profileBG_White">
            <img :src="backend + detailMSGSelected.user_send.profile_picture" v-if="detailMSGSelected.user_send.profile_picture" class="alligator-turtle"/>
            <span class="headline " v-else>
{{(detailMSGSelected.user_send.display_name.length>=2)? detailMSGSelected.user_send.display_name.charAt(0)+detailMSGSelected.user_send.display_name.charAt(1):detailMSGSelected.user_send.display_name.charAt(0)}}
            </span>
          </v-avatar>
        </v-flex>
        <v-flex xs9 xl9 md9 sm9 lg9>
          <div style="display: inline-block;">
            <!-- {{detailMSGSelected.user_send}} -->
          <p style="font-weight: 600; color: white;">{{detailMSGSelected.user_send.display_name}}</p>
          <p style="color: white;" v-if="detailMSGSelected.message_type =='text' || detailMSGSelected.message_type =='reply_text'">{{detailMSGSelected.message_data.text}}</p>
          <p style="color: white;" v-else-if="detailMSGSelected.message_type =='image'">รูป</p>
</div>
          <img  :src="backend + detailMSGSelected.message_data.url" style="float:right;display: inline-block;max-height: 40px;max-width: 20vw;border-radius: 10px;cursor: pointer;" class="contentimage"  v-if="detailMSGSelected.message_type == 'image'" >



        </v-flex>
        <v-flex xs1 xl1 md1 sm1 lg1 style="text-align: right;">
          <v-icon color="white" @click="showmention = false;">close</v-icon>
        </v-flex>
      </v-layout>
    </v-flex>









  <div class="typer" v-if="roomDetail_SepType.status !== 'pending'">






           <v-textarea
              solo
              placeholder="พิมพ์ข้อความ...."
              hide-details
              height="45"
              rows="1"
              @keyup.enter.exact="sendMessage" 
              v-model="content"
            ></v-textarea>

          <v-menu top offset-y>
      <template v-slot:activator="{ on }">
          <v-btn
            dark
            v-on="on"
            icon
            class="emoji-panel">
            <v-icon color="#2562af">add_circle_outline</v-icon>
          </v-btn>
        </template>
        <v-card style="height: 60px;width: 80vw;border-radius: 10px;
  background: #0b2a52 !important;">
          <v-layout >
            <v-flex xs4 xl4 md4 sm4 lg4>
           <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div class="btnmsgMore" style="margin:5px;" @click="uppicfile()">
              <v-icon style="font-size: 30px; color: #2562af;" v-on="on">far fa-file-image</v-icon>
            </div>
               </template>
              <span>ส่งรูป</span>
      </v-tooltip>
        


          </v-flex>
          <v-flex xs4 xl4 md4 sm4 lg4 >
             <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div class="btnmsgMore" style="margin:5px;" @click="upfile()">
           
              <v-icon style="font-size: 30px; color: #2562af;" v-on="on">fas fa-file-alt</v-icon>
            </div>
               </template>
              <span>ส่งไฟล์</span>
      </v-tooltip>

          </v-flex>
        </v-layout>
        </v-card>
      </v-menu>
        </div>



<div style="display:none;">
      <input multiple type="file" id="uploadpic" @change="onimgSelected($event)" accept="image/*" />
      <input multiple type="file" id="uploadfileChat" @change="onimgSelected($event)"/>

    </div>
  </div>
  <!-- :UserMemberDetail="UserMemberDetail" -->
  <ShowDetailmemberDialog :dialogGroupMember="dialogGroupMember"  :room_id="room_id"  @closeDetailMember="closeDetailMember"></ShowDetailmemberDialog>

<EditGroupNameDialog :dialogGroupName="dialogGroupName" :roomDetail_SepType="roomDetail_SepType" @closeEditGroupname="closeEditGroupname"></EditGroupNameDialog>

<ShowDetailUserDialog :dialogDetailUser="dialogDetailUser" :UserDetail_who="UserDetail_who" @closeDetailUser="closeDetailUser"></ShowDetailUserDialog>

<NoteDialog :dialogNote="dialogNote" :note_id="note_id" @closeNote="closeNote" @changeNote="changeNote"></NoteDialog>

    </div>
</template>

<script>
  import Vue from 'vue'
import gql from 'graphql-tag'
import { sync } from 'vuex-pathify'
import { Momenttime, Decode, Encode } from '@/services'
import { vplayer } from 'vue-hls-player'
import pdf from 'vue-pdf'
import LinkPrevue from 'link-prevue'
import { VueContext } from 'vue-context';
import EditGroupNameDialog from '@/components/mail/Edit/edit_groupname'
import ShowDetailUserDialog from '@/components/mail/Detail/detail_user'
import ShowDetailmemberDialog from '@/components/mail/Detail/detail_memberGroup'
import NoteDialog from '@/components/mail/Detail/NoteDialog'
// import { mdiFileDocumentMultipleOutline } from '@mdi/js';
var _ = require('lodash')
// import pdf from 'pdfvuer'
// import pdfvuer from 'pdfvuer'

const subscript_messageInroom = gql`
  subscription MySubscription($room_id: uuid, $user_id: uuid) {
  message(where: {room_id: {_eq: $room_id}}, limit: 1, order_by: {create_at: desc}) {
    create_at
    message_data
    message_id
    user_send {
      user_id
      display_name
      email
      username
      profile_picture
    }
    send_by
    room_id
    message_type

  }
}
`

    // get_read_in_room(order_by: {time_read: desc}, where: {user_id: {_neq: $user_id}}) {
    //   member_id
    //   time_read
    //   user_id
    // }

const subscript_readInroom = gql`
  subscription MySubscription($room_id: uuid, $user_id: uuid) {
  member_read_in_room(where: {room_id: {_eq: $room_id}, user_id: {_neq: $user_id}}, limit: 1, order_by: {create_at: desc, time_read: desc}) {
    member_id
    message_id
    time_read
    user_id
  }
}
`

const getMessage_read_new = gql`
query MyQuery($room_id: uuid, $user_id: uuid) {
  member_read_in_room(where: {room_id: {_eq: $room_id},user_id: {_eq: $user_id}}, limit: 20, order_by: {create_at: desc, time_read: desc}) {
    member_id
    message_id
    time_read
    user_id
  }
}
`

const getMessage_read = gql`
query MyQuery($message_id: uuid, $user_id: uuid) {
  member_read_in_room(where: {message_id: {_eq: $message_id},user_id: {_neq: $user_id}}) {
    member_id
    message_id
    time_read
    user_id
    room_id
  }
}
`




const subscript_friendOnline = gql`
subscription($user_id: uuid) {
  user_online(where: {user_id: {_eq: $user_id}}) {
    user_id
    username
    display_name
  }
}
`


// const get_historyMessage = gql`
//     query MyQuery($create_at: timestamptz, $room_id: uuid) {
//   message(where: {room_id: {_eq: $room_id}, create_at: {_lt: $create_at}}, limit: 20, order_by: {create_at: desc}) {
//     create_at
//     message_data
//     message_id
//     user_send {
//       user_id
//       display_name
//       email
//       username
//       profile_picture
//     }
//     send_by
//     room_id
//     message_type
//   }
// }
// `


const get_historyMessage = gql`
  query MyQuery($room_id: uuid, $user_id: uuid, $create_at: timestamptz) {
  message(where: {room_id: {_eq: $room_id}, create_at: {_lt: $create_at}, read_in_room: {}}, limit: 20, order_by: {create_at: desc, read_in_room_aggregate: {count: desc}}) {
    create_at
    message_data
    message_id
    user_send {
      user_id
      display_name
      email
      username
      profile_picture
    }
    send_by
    room_id
    message_type
    get_read_in_room(order_by: {time_read: desc}, where: {user_id: {_neq: $user_id}}) {
      member_id
      time_read
      user_id
    }
  }
}`



const get_history = gql`
query MyQuery($create_at: timestamptz, $room_id: uuid, $message_type: String) {
  message(where: {room_id: {_eq: $room_id}, message_type: {_eq: $message_type}, create_at: {_lt: $create_at}}, limit: 50, order_by: {create_at: desc}) {
    create_at
    message_data
    message_id
    user_send {
      user_id
      display_name
      email
      username
      profile_picture
    }
    send_by
  }
}
`

const get_roomDetail = gql`
query MyQuery($user_id: uuid, $room_id: uuid)  {
  roomdetail: member(where: {room_id: {_eq: $room_id}}) {
    room_id
    time_read
    user_id
    member_id
    status
    room {
      room_name
      room_picture
      room_type
    }
    user {
      display_name
      profile_picture
      username
      email
      last_seen
    }
  }
}
`


const subscription_roomDetail = gql`
subscription($user_id: uuid, $room_id: uuid) {
  roomdetail: member(where: {room_id: {_eq: $room_id}}) {
    room_id
    time_read
    user_id
    member_id
    status
    room {
      room_name
      room_picture
      room_type
    }
    user {
      display_name
      profile_picture
      username
      email
      last_seen
    }
  }
}
`



const subscription_roomMessageCancel = gql`
subscription MySubscription($room_id: uuid) {
  message(where: {room_id: {_eq: $room_id}, message_type: {_eq: "unsent_message"}}, limit: 1, order_by: {update_at: desc}) {
    message_id
  }
}
`



const SEND_MESSAGE = gql`
 mutation SendMessage($message_data: jsonb, $message_type: String, $room_id: uuid, $send_by: uuid) {
  insert_message_one(object: {message_data: $message_data, message_type: $message_type, send_by: $send_by, room_id: $room_id}) {
    create_at
    message_data
    room_id
    send_by
    message_type
    message_id
    user_send {
      user_id
      display_name
      profile_picture
      email
      username
    }
    get_read_in_room(order_by: {time_read: desc}, where: {user_id: {_neq: $send_by}}) {
      member_id
      time_read
    }
  }
}`



const CANCEL_MESSAGE = gql`
mutation ($message_id: uuid!) {
  update_message(where: {message_id: {_eq: $message_id}}, _set: {message_type: "unsent_message", update_at: "now()"}) {
    returning {
      create_at
      message_data
      message_id
      message_type
      room_id
      send_by
      update_at
    }
  }
}
`

const getUser_detail = gql`
query MyQuery ($user_id: [uuid!]) {
  users(where: {user_id: {_in: $user_id}}) {
    display_name
    profile_picture
  }
}
`

const Reply_message = gql`
mutation SendMessage($message_type: String!, $message_data: jsonb!, $room_id: uuid!, $send_by: uuid!) {
  insert_message(objects: {message_type: $message_type, message_data: $message_data, room_id: $room_id, send_by: $send_by}) {
    returning {
      send_by
      room_id
      message_type
      message_id
      message_data
      create_at
      user_send {
        user_id
        display_name
        profile_picture
        email
        username
      }
    }
  }
}
`

const getMessage_reply_detail = gql`
query MyQuery($message_id: uuid) {
  message(where: {message_id: {_eq: $message_id}}) {
    create_at
    message_type
    message_data
    message_id
    user_send {
      user_id
      display_name
      email
      username
      profile_picture
    }
    send_by
  }
}
`


const SET_TIME_READ = gql`
mutation ($user_id: uuid!, $room_id: uuid!) {
  update_member(where: {room_id: {_eq: $room_id}, _and: {user_id: {_eq: $user_id}}}, _set: {time_read: "now()"}) {
    returning {
      time_read
      room_id
      member_id
    }
  }
}
`

const CREATE_NOTES = gql`
mutation ($note_data: jsonb, $room_id: uuid, $create_by: uuid) {
  insert_notes_one(object: {create_by: $create_by, note_data: $note_data, room_id: $room_id}) {
    note_id
    create_at
    create_by
    note_data
    room_id
  }
  insert_message_one(object: {message_data: $note_data, message_type: "note", send_by: $create_by, room_id: $room_id}) {
    create_at
    message_data
    room_id
    send_by
    message_type
    message_id
    user_send {
      user_id
      display_name
      profile_picture
      email
      username
    }
  }
}
`

const UPDATE_NOTE_ID = gql`
mutation ($message_id: uuid, $note_data: jsonb, $room_id: uuid, $user_send: uuid) {
  update_message(where: {message_id: {_eq: $message_id}, room_id: {_eq: $room_id}, send_by: {_eq: $user_send}}, _set: {message_data: $note_data}) {
    returning {
      create_at
      message_data
      message_id
      message_type
      room_id
      send_by
      update_at
      user_send {
        create_at
        display_name
        email
        last_seen
        profile_picture
        status
        user_id
        username
      }
    }
  }
}
`

const GET_NOTES = gql`
query MyQuery($room_id: uuid) {
  notes(where: {room_id: {_eq: $room_id}, 
status_show: {_eq: true}}) {
    user_created {
      display_name
      profile_picture
      user_id
    }
    create_at
    create_by
    last_update
    note_data
    note_id
    room_id
    status_show
  }
}

`









export default {
  apollo: {
    $subscribe: {
      message: {
        query: subscript_messageInroom,
        variables () {
          return {
            room_id: this.room_id,
            user_id: this.user_id
          }
        },
        result (data) {
          // console.log(data)
          // var scroll = false
          // var container = this.$refs.chatContainer
          // if (container.scrollHeight - container.scrollTop <= container.clientHeight + 25) {
          //   scroll = true
          // }
          this.message.push.apply(this.message, data.data.message)
          // console.log(this.message)
          
          Vue.set(this.message, 'property', this.message)
          this.message = _.sortBy(this.message, function(dateObj) {
            return new Date(dateObj.create_at)
          })
          // console.log(this.message[this.message.length - 1])
          // console.log(this.message[this.message.length - 1]['get_read_in_room'])
          // if (this.message[this.message.length - 1]['get_read_in_room'] === undefined) {
            // console.log(data.data.message[0])
            // console.log(data.data.message[0].get_read_in_room)


            // if (data.data.message[0].message_type == 'text') {
            //   this.message[this.message.length - 1]['get_read_in_room'] = []
            // } else if (data.data.message[0].message_type !== 'system') {
            //   // console.log('========')
            //   this.$apollo.query({
            //     query: getMessage_read,
            //     variables: {
            //       message_id: data.data.message[0].message_id,
            //       user_id: this.user_id
            //     },
            //     fetchPolicy: 'no-cache'
            //   }).then((response) => {
            //     // console.log('response')
            //     this.message[this.message.length - 1]['get_read_in_room'] = response.data.member_read_in_room
            //     this.message[this.message.length - 1].get_read_in_room = _.unionBy(this.message[this.message.length - 1].get_read_in_room, 'user_id')
            //     // console.log(this.message)
            //   })

            // }



          //   // console.log(this.message[this.message.length - 1])
          // }
          // this.message[this.message.length - 1].get_read_in_room = []
          // this.message[this.message.length - 1].get_read_in_room = _.unionBy(this.message[this.message.length - 1].get_read_in_room, 'user_id')
          this.message = _.unionBy(this.message, 'message_id')
          if(data.data.message[0].message_type === 'system') {

            this.getdetailroom()
          }
          this.setTimeRead()
          this.messagedown()

          // if (scroll) {
          //   // this.scrollToEnd()
          //   setTimeout(this.scrollToEnd, 200)
          // } 
        }
      },
      read_in_room: {
        query: subscript_readInroom,
        variables () {
          return {
            room_id: this.room_id,
            user_id: this.user_id
          }
        },
        result (data) {
          // // console.log('test' + this.user_id)
          // // var i
          // // for (i = 0; i < data.data.member_read_in_room.length; i++) {
          //   var indexid = _.findIndex(this.message, function(o) {
          //     return o.message_id === data.data.member_read_in_room[0].message_id
          //   })
          //   console.log(indexid)
          //   if (indexid != -1) {
          //     if (this.message[indexid].get_read_in_room) {
          //       this.message[indexid].get_read_in_room.push(data.data.member_read_in_room[0])
          //     } else {
          //       this.message[indexid].get_read_in_room = data.data.member_read_in_room
          //     }
          //     this.message[indexid].get_read_in_room = _.unionBy(this.message[indexid].get_read_in_room, 'user_id')
          //   }
          // // }
          // var me = this
          if(data.data.member_read_in_room[0].user_id != this.user_id) {
            this.$apollo.query({
              query: getMessage_read_new,
              variables: {
                room_id: this.room_id,
                user_id: data.data.member_read_in_room[0].user_id
              },
              fetchPolicy: 'no-cache'
            }).then((response) => {
              var i
              var index = data.data.member_read_in_room.length-1
              for (i = this.message.length-1; i >= 0; i--) {
                if(_.findIndex(this.message[i].get_read_in_room, function(o) { return o.user_id == data.data.member_read_in_room[0].user_id; }) != -1) {
                  break;
                } else {
                  if (this.message[i].get_read_in_room) {
                    this.message[i].get_read_in_room.push(data.data.member_read_in_room[index])
                  } else {
                    this.message[i].get_read_in_room = data.data.member_read_in_room[index]
                  }
                  this.message[i].get_read_in_room = _.unionBy(this.message[index].get_read_in_room, 'user_id')
                  index = index++

                }

                
              }
            })
          }
        }
      },
      messageCancel: {
        query: subscription_roomMessageCancel,
        variables () {
          return {
            room_id: this.room_id,
          }
        },
        result (data) {
          var indexid = _.findIndex(this.message, function(o) {
            return o.message_id === data.data.message[0].message_id
          })
          this.message[indexid].message_type = 'unsent_message'
          var indexid_reply = _.keys(_.pickBy(this.message, function(o) {
            return o.message_data.message_id_reply === data.data.message[0].message_id
          }))
          var me = this
          _.forEach(indexid_reply, function(value) {
            // me.message[value].message_type = 'reply_unsent_text'
            me.message[value].message_data.message_data_reply.message_type = 'unsent_message'
          });
        },
      }
    }
  },
  data () {
      return {
          note_data: "",
          content: "",
          message: [],
          isLoading: false,
          stateBTN_loadmsg: true,
          roomDetail: {},
          roomDetail_SepType: {},
          userOnline: false,
          dialogmore_msg: false,
          selectFile: null,
          backend: process.env.VUE_APP_API,
          loadedRatio: 0,
          Authorization: {},
          ListMenuRightClick: [],
          menuRightClick: false,
          stateChat:'chat',
          stateMenu: 'image',
          listImage: [],
          listFile: [],
          listNote: [],
          my_picture_Group: '',
          groupname: '',
          dialogGroupName: false,
          dialogGroupMember: false,
          dialogDetailUser: false,
          UserDetail_who: {},
          showmention: false,
          detailMSGSelected: {},
          modalCreate: false,
          createbuttonnote_show: true,
          note_id: '',
          dialogNote: false,
          MemberuserDetail: [],
          scrollable: {'overflow-y': 'auto'}
      }
  },
  created() {
    // console.log(new Date())
    this.user_id = Decode.decodeToken(localStorage.getItem('user_id'))
    this.getdetailroom()
    this.gethistoryImage(new Date())
    this.gethistoryFile(new Date())
    this.gethistoryMessage(new Date())
    this.Authorization = {headers: {'Authorization': 'Bearer ' + Decode.decodeToken(localStorage.getItem('auth_token'))}}
    this.get_list_note()
    // this.checkOnline(this.roomDetail[0].user_id)
  },
  mounted () {
    // this.scrollToEnd()    
    setTimeout(this.scrollToEnd, 2000)
  },
  components: {
    pdf,
    VueContext,
    LinkPrevue,
    EditGroupNameDialog,
    ShowDetailUserDialog,
    ShowDetailmemberDialog,
    NoteDialog,
    vplayer
  },
  computed: {
    room_id() {
      return this.$route.query.id
    }
  },
  watch: {
    // '$refs.vueSimpleContextMenu' () {
    //   console.log(this.$refs.vueSimpleContextMenu)
    // },
    message () {
      // console.log(this.message)
    },
    room_id () {
      this.message = []
      this.getdetailroom()
      this.gethistoryImage(new Date())
      this.gethistoryFile(new Date())
      this.gethistoryMessage(new Date())
      // this.gethistoryMessage(this.message[0].create_at)
    },
    stateChat () {
      this.gethistoryImage(new Date())
    },
    stateMenu () {
      if (this.stateMenu == 'image') {
        this.gethistoryImage(new Date())
      } else if (this.stateMenu == 'file') {
        this.gethistoryFile(new Date())
      } else if (this.stateMenu == 'note') {
        // this.gethistoryFile(new Date())
      }
    }
  },
  methods: {
    isBlank(str) {
      return (!str || /^\s*$/.test(str))
    },
    isEmpty(str) {
      return (!str || str.length === 0)
    },
    messagedown () {
      // console.log('down')
      // var scroll = false
      // var container = this.$refs.chatContainer
      this.$nextTick(() => {
        var container = this.$refs.chatContainer
        // console.log(container.scrollHeight)
        // console.log(container.scrollTop)
        // console.log(container.clientHeight)

        // container.scrollTop = container.scrollHeight
        if (container) {
          if ((container.scrollHeight - container.scrollTop) <= container.clientHeight + 50) {
            // console.log('downdown')
            setTimeout(this.scrollToEnd, 200)
          }
        }
        
      })
    },
    showdetail_memberGroup () {
      // console.log(this.roomDetail)
      this.MemberuserDetail = this.roomDetail
      this.dialogGroupMember = true
      // this.MemberuserDetail = this.roomDetail
    },
    changeNote (value) {
      this.get_list_note()
    },
    openNote_byid (id) {
      // console.log(id)
      this.note_id = id
      this.dialogNote = true
    },
    closeNote (value) {
      this.dialogNote = value
    },
    get_list_note () {
      this.$apollo.mutate({
        mutation: GET_NOTES,
        variables: {
          room_id: this.room_id
        }
      }).then(data => {
        // console.log('data.data.notes')
        // console.log(data.data.notes)
        this.listNote = data.data.notes
        // this.closemodalnote()
        // UPDATE_NOTE_ID
      })
    },
    create_note () {
      // console.log(this.note_data)
      this.$apollo.mutate({
        mutation: CREATE_NOTES,
        variables: {
          note_data: {
            text: this.note_data
          },
          room_id: this.room_id,
          create_by: this.user_id
        }
      }).then(data => {
        // console.log(data)
        var note_id = data.data.insert_notes_one.note_id
        var message_id = data.data.insert_message_one.message_id
        // UPDATE_NOTE_ID
        this.$apollo.mutate({
          mutation: UPDATE_NOTE_ID,
          variables: {
            note_data: {
              text: this.note_data,
              note_id: note_id
            },
            message_id: message_id,
            room_id: this.room_id,
            user_send: this.user_id
          }
        }).then(data2 => {
          // console.log(data2)
          this.note_data = ""
          this.get_list_note()
          this.closemodalnote()
          // UPDATE_NOTE_ID
        })
      })
    },
    openCreateNote (){
      var modal = document.getElementById('myModalNote')
      modal.style.display = 'block'
      this.createbuttonnote_show = false
    },
    zoom (item) {
      // console.log(item)
      var modal = document.getElementById('myModalImage')
      var modalImg = document.getElementById('img01')
      modal.style.display = 'block'
      modalImg.src = process.env.VUE_APP_API + item.message_data.url
      // if (item.path_pic === undefined) {
      //   this.picSend = localStorage.getItem('profilepicture')
      // } else {
      //   this.picSend = item.path_pic
      // }
      // this.nicknameSend = item.nickname
      // this.filenameSend = item.file_name
      // this.dateSend = this.dateMoment(item.timestamp)
      // this.timeSend = this.timeMoment(item.timestamp)
      // this.tokenmsgSend = item.tokenmessage
      // this.pathSend = item.message
      // this.typeuserSend = item.type
    },
    closemodal () {
      var modal = document.getElementById('myModalImage')
      modal.style.display = 'none'
    },
    closemodalnote () {
      // console.log('test')
      var modal = document.getElementById('myModalNote')
      modal.style.display = 'none'
      this.createbuttonnote_show = true
    },
    setTimeRead() {
      this.$apollo.mutate({
        mutation: SET_TIME_READ,
        variables: {
          user_id: this.user_id,
          room_id: this.room_id
        }
      })
    },
    // async GetDisplayUser (user_id) {
    //   var displayname = await this.$apollo.query({
    //     query: getUser_detail,
    //     variables: {
    //       user_id: user_id
    //     }
    //   }).then((response) => {
    //     displayname = _.map(response.data.users,'display_name')
    //     return displayname
    //   })
    //   return displayname.toString()//.replace(",", ", ")
    // },
    async GetDisplayUser (users) {
      // console.log(users)
      // console.log(this.user_id)
      // console.log('=============')
      if (users.length == 1) {
        // return(users[0].user_id == this.user_id)
        return (users[0].user_id == this.user_id)? 'คุณ':users[0].display_name
      } else {
        var user_displayname = ''
        for (var i = 0; i < users.length; i += 1) {
          if (i == 0) {
            user_displayname = (users[0].user_id == this.user_id)? 'คุณ':users[0].display_name
          } else {
            users[i].display_name = (users[i].user_id == this.user_id)? 'คุณ':users[i].display_name
            user_displayname = user_displayname + ', ' + users[i].display_name
            if (i == users.length - 1) {
              return user_displayname
            }
          }
        }
      }
    },
    async getReplyMessage (message_id) {
      var displayname = (await this.$apollo.query({
        query: getMessage_reply_detail,
        variables: {
          message_id: message_id
        }
      }).then((response) => {
        return response.data.message[0]
      }))
      return displayname
    },
    closeEditGroupname (value, stateChangeName, Name) {
      this.dialogGroupName = value
      if (stateChangeName) {
        this.groupname = Name
        this.roomDetail_SepType.room.room_name = Name
      }
    },
    closeDetailUser (value) {
      this.dialogDetailUser = value
      // this.UserMemberDetail = value
    },
    closeDetailMember (value) {
      this.dialogGroupMember = value
    },
    switchState () {
      if (this.stateChat == 'menu') {
        this.stateChat = 'chat'
        setTimeout(this.scrollToEnd, 200)
      } else {
        this.stateChat = 'menu'
      }
    },
    cancleMessage (message_id) {
      this.$apollo.mutate({
        mutation: CANCEL_MESSAGE,
        variables: {
            message_id: message_id
        }
      }).then(data => {
        var indexid = _.findIndex(this.message, function(o) {
          return o.message_id === data.data.update_message.returning[0].message_id
        })
        this.message[indexid].message_type = 'unsent_message'
      })
    },
    RightClickDialog ($event, list, item) {
      this.ListMenuRightClick = []
      // if (this.user_id === item.send_by) {
      if (list.includes("reply")) {
        this.ListMenuRightClick.push({message: 'ตอบกลับ', methods:'reply', detail: item})
      }

      if (list.includes("cancel") && this.user_id === item.send_by) {
        this.ListMenuRightClick.push({message: 'ยกเลิกข้อความ', methods:'cancel', detail: item})
      }

      if(this.ListMenuRightClick.length != 0) {
        this.rightclickdialog = true
        this.$refs.vueSimpleContextMenu.open($event)
      }
        // console.log(this.$refs.vueSimpleContextMenu.$options)
        // this.scrollable = {'overflow-y': 'hidden'}
      // } else {
      //   this.$refs.vueSimpleContextMenu.close()
      //   // console.log(this.$refs.vueSimpleContextMenu.$options)
      //   // this.scrollable = {'overflow-y': 'auto'}
      // }
    },
    SelectMenuRightClick (event, detail) {
      if (event == 'cancel') {
        this.cancleMessage(detail.message_id)
      } else if (event == 'reply') {
        // console.log(detail)
        this.showmention = true
        this.detailMSGSelected = detail
        // console.log(this.detailMSGSelected)
      }
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data) //+ ' น.'
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    cancelGroup () {
      var reqestBody = {
        "room_id": this.room_id,
        "status": "decline"
      }
      this.axios.post(process.env.VUE_APP_API + '/acceptOrDeclineGroup', reqestBody, this.Authorization).then((response) => {
        this.$router.push('/list_room')
      })
    },
    acceptGroup () {
      var reqestBody = {
        "room_id": this.room_id,
        "status": "accept"
      }
      this.axios.post(process.env.VUE_APP_API + '/acceptOrDeclineGroup', reqestBody, this.Authorization).then((response) => {
        this.getdetailroom()
      })
    },
    convert(msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      return processedContent
    },
    convertURL (msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0 ) {
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
    },
    downloadFile (file) {
      this.axios.get(this.backend + file.url, { responseType: 'blob' }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', file.file_name)
        document.body.appendChild(link)
        link.click()
      })
    },
    openFilePDF (file) {
      const link = document.createElement('a')
      link.href = this.backend + file.url
      link.target = "_blank"
      document.body.appendChild(link)
      link.click()
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls','xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fas fa-file-alt'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'media'
      } else if (audio.includes(extension)) {
        return 'audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    onimgSelected(data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      var sizefile = []
      for (let i = 0; i < uploadedFiles.length; i++) {
        this.selectFile = data.target.files[i]
        var uploadFile = new FormData()
        uploadFile.append('file', this.selectFile, this.selectFile.name)
        uploadFile.append('room_id', this.room_id)
        uploadFile.append('send_by', this.user_id)
        this.axios.post(process.env.VUE_APP_API_v2 + '/sendFile', uploadFile, this.Authorization).then((response) => {
          // this.scrollToEnd()
          setTimeout(this.scrollToEnd, 200)
        }, (error) => {
          console.log(error)
        })
      }
    },
    uppicfile () {
      // console.log('uppicfile')
      document.querySelector('#uploadpic').click()
    },
    upfile () {
      // console.log('upfile')
      document.querySelector('#uploadfileChat').click()
    },
    openModalMessage () {
      this.dialogmore_msg = true
    },
    checkOnline (user_id) {
      var me = this
      this.$apollo.subscribe({
        query: subscript_friendOnline,
        variables: {
          user_id: user_id
        }
      }).subscribe({
        next (data) {
          // console.log(data);
          (data.data.user_online.length > 0)? me.userOnline = true: me.userOnline = false;
        },
        error (error) {
          console.error(error)
        }
      })
    },
    getdetailroom () {
      this.$apollo.query({
        query: get_roomDetail,
        variables: {
          room_id: this.room_id,
          user_id: this.user_id
        },
        fetchPolicy: 'no-cache'
      }).then((response) => {
        
        this.roomDetail = response.data.roomdetail
        if (this.roomDetail[0].room.room_type === 'user') {
          var me_id = this.user_id
          this.roomDetail_SepType = _.partition(this.roomDetail, function(o) { return o.user_id !== me_id })[0][0]
          // console.log(this.roomDetail_SepType)
          if(this.roomDetail_SepType.user.profile_picture) {
            this.my_picture_Group = this.backend + this.roomDetail_SepType.user.profile_picture
          } else {
            this.my_picture_Group = ''
          }

        } else if (this.roomDetail[0].room.room_type === 'group') {
          var me_id = this.user_id
          this.roomDetail_SepType = _.partition(this.roomDetail, function(o) { return o.user_id == me_id })[0][0]
          if(this.roomDetail_SepType.room.room_picture) {
            this.my_picture_Group = this.backend + this.roomDetail_SepType.room.room_picture
          } else {
            this.my_picture_Group = ''
          }
          this.groupname = this.roomDetail_SepType.room.room_name
        }
        this.checkOnline(this.roomDetail[0].user_id)
      })
    },
    countgroupMember (group) {
      return _.partition(this.roomDetail, function(o) { return o.status == 'active' })[0]
    },
    gotoMessage (token) {
      if (token) {
        var myElement = document.getElementById(token)
        if (myElement) {
          myElement.scrollIntoView({duration: true, behavior: 'smooth', block: 'end', queue: false, specialEasing: null})
          window.location.hash = token
        }
      }
    },
    sendMessage() {
      if (!this.isBlank(this.content) && !this.isEmpty(this.content)) {
        if (this.showmention) {
          // if (!this.isBlank(this.content) && !this.isEmpty(this.content)) {
          var reply_data = {}
          reply_data = JSON.parse(JSON.stringify(this.detailMSGSelected))
          if (reply_data.message_type == 'reply_text') {
            // console.log('test')
            reply_data.message_data['message_data_reply'] = {}
            // console.log(reply_data)
          }
          this.$apollo.mutate({
            mutation: Reply_message,
            variables: {
                message_data: {"text": this.content.trim(),"message_id_reply": this.detailMSGSelected.message_id, "message_data_reply": reply_data},
                message_type: "reply_text",
                room_id: this.room_id,
                send_by: this.user_id
            }
          }).then(data => {
            this.showmention = false
            this.message.push(data.data.insert_message.returning[0])
            setTimeout(this.scrollToEnd, 200)
            this.content = ""
          })
        } else {
          this.$apollo.mutate({
            mutation: SEND_MESSAGE,
            variables: {
                message_data: {"text": this.content.trim()},
                message_type: "text",
                room_id: this.room_id,
                send_by: this.user_id
            }
          }).then(data => {
            this.message.push(data.data.insert_message_one)
            // this.scrollToEnd()
            setTimeout(this.scrollToEnd, 200)
            this.content = ""
          })
        }
      }
    },
    onScroll () {
      let scrollValue = this.$refs.chatContainer.scrollTop
      if (scrollValue == 0 && this.isLoading == false) {
        this.gethistoryMessage(this.message[0]['create_at'])
      }
      // console.log(scrollValue)
      this.$refs.vueSimpleContextMenu.close()
    },
    scrollToEnd () {
      this.$nextTick(() => {
        var container = this.$refs.chatContainer
        container.scrollTop = container.scrollHeight
      })
    },
    gethistoryMessage(date) {
      this.stateBTN_loadmsg = false
      this.$apollo.query({
        query: get_historyMessage,
        variables: {
          room_id: this.room_id,
          user_id: this.user_id,
          create_at: date
        }
      }).then((response) => {
        // console.log(response.data.message)
        if (response.data.message.length) {
          this.message.unshift.apply(this.message, response.data.message.reverse())
          this.message = _.sortBy(this.message, function(dateObj) {
              return new Date(dateObj.create_at)
          })
          this.message = _.unionBy(this.message, 'message_id')
          this.$nextTick(() => {
            this.gotoMessage(response.data.message[response.data.message.length - 1].message_id)
          })
          if (response.data.message.length === 20) {
            this.stateBTN_loadmsg = true
          } else {
            this.stateBTN_loadmsg = false
          }
        } else {
          this.stateBTN_loadmsg = false
        }
      })
    },
    gethistoryImage(date) {
      this.stateBTN_loadmsg = false
      this.$apollo.query({
        query: get_history,
        variables: {
          room_id: this.room_id,
          create_at: date,
          message_type: 'image'
        },
        fetchPolicy: 'no-cache'
      }).then((response) => {
        this.listImage = response.data.message
      })
    },
    gethistoryFile(date) {
      this.stateBTN_loadmsg = false
      this.$apollo.query({
        query: get_history,
        variables: {
          room_id: this.room_id,
          create_at: date,
          message_type: 'file'
        },
        fetchPolicy: 'no-cache'
      }).then((response) => {
        this.listFile = response.data.message
      })
    },
    gotopath (path) {
      this.$router.push(path)
    },
    uppic () {
      $('#file-input').click()
    },
    previewImageGroup (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('room_id', this.room_id)
      this.axios.post(process.env.VUE_APP_API + '/updateGroupPicture', uploadFile, this.Authorization).then((response) => {
        if (response.data.message === 'success') {
          // console.log(response.data.data.url)
          this.my_picture_Group = response.data.data.url
          // this.getDetail()
        }
      })
    },
    getdetailUser_who(user) {
      // console.log(user)
      this.dialogDetailUser = true
      this.UserDetail_who = user
    },
    leaveGroup () {
      this.$swal({
        text: 'คุณต้องการออกจากกลุ่มใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่ใช่',
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var reqestBody = {
            "room_id": this.room_id
          }
          this.axios.post(process.env.VUE_APP_API + '/leftGroup', reqestBody, this.Authorization).then((response) => {
            this.gotopath('/list_room')
          })
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.vplayer video {
        max-width: 60vw;
    max-height: 30vh;
}
>>>.vplayer .player__controls {
    max-width: 60vw !important;
    /*width: auto;*/
}
.CSChatThai {
 /*font-family: 'CS ChatThaiUI' !important;*/
 word-wrap: break-word;
}
.scrollable {
    overflow-y: auto;
    height: 90vh;
  }
  .typer{
    box-sizing: border-box;
    display: flex;
    align-items: center;
    bottom: 0;
    /*height: 70px !important;*/
    width: 100%;
    background-color: transparent;
    box-shadow: none;
  }
  .typer .v-text-field{
    position: absolute;
    left: 2.5rem;
    padding: 0 1rem;
    width: 90%;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 1.25rem;
  }
  .chat-container{
    box-sizing: border-box;
    height: calc(100vh - 145px) !important;
    overflow-y: auto;
        width: 100%;
    padding: 10px 10px;
    background-color: #fafafa !important;
  }
  .message{
    margin-bottom: 3px;
  }
  .message.own{
    text-align: right;
    margin-left: 0px !important;margin-left: 0px !important;
  }
  .message.own .content{
    color: white !important;
    background-color: #0c82e0;
    text-align: left;
    margin-left: 0px !important;
  }
  .message.own .contentnot_support{
    color: white !important;
    background-color: #0c82e0;
    text-align: left;
    margin-left: 0px !important;
  }
  .message.own .contentNote {
    width: 60vw;
    margin-left: 0px !important;
    margin-top: 5px;
  }
  .message.own .contentfile{
    color: white !important;
    background-color: #0c82e0;
    margin-left: 0px !important;
  }
  .message.own .contentvideo{
    margin-left: 0px !important;
  }

  .message.own .contentimage{
    margin-left: 0px !important;
  }

  .message.own .contentvideo{
    margin-left: 0px !important;
  }


  .message.own .contentfile .iconFile {
    color: white; 
 /*   width: 40px; 
    height: 40px; */
    margin-left: 0px !important;
    font-size: 20px;
    margin-right: 10px;
  }
  .chat-container .username{
    font-size: 13px;
    font-weight: bold;
    color: #1569bb;
  }
  .chat-container .content{
    padding: 10px;
    background-color: #efefef;
    border-radius: 23px;
    display:inline-block;
    box-shadow: none;
    max-width: 60vw;
    word-wrap: break-word;
    font-size: 13px;
    margin-left: 35px;
  } 
  .chat-container .contentnot_support {
    padding: 10px;
    background-color: #efefef;
    border-radius: 23px;
    display:inline-block;
    box-shadow: none;
    max-width: 60vw;
    word-wrap: break-word;
    font-size: 13px;
    margin-left: 35px;
    color: gray !important;
  }
  .chat-container .contentNote {
    border-radius: 10px;
    display:inline-block;
    box-shadow: none;
    font-size: 13px;
    margin-left: 35px;
  }
.chat-container .contentvideo{
    border-radius: 10px;
    display:inline-block;
    box-shadow: none;
    font-size: 13px;
    margin-left: 35px;
  }
  .chat-container .contentimage{
    border-radius: 10px;
    display:inline-block;
    box-shadow: none;
    font-size: 13px;
    margin-left: 35px;
  }
  .chat-container .contentvideo{
    border-radius: 10px;
    display:inline-block;
    box-shadow: none;
    font-size: 13px;
    margin-left: 35px;
  }
  .chat-container .contentfile{
    padding: 10px;
    background-color: #efefef;
    border-radius: 10px;
    display:inline-block;
    box-shadow: none;
    max-width: 60vw;
    word-wrap: break-word;
    font-size: 13px;
    margin-left: 35px;
  }

 .chat-container .contentfile .iconFile {
    color: #1569bb; 
 /*   width: 40px; 
    height: 40px;*/
    font-size: 20px;
    margin-right: 10px;
  }
   /* @media (max-width: 480px) {
    .chat-container .content{
      max-width: 60%;
    }
  } */
>>>.v-text-field--solo input {
    margin: auto !important;
}
/*>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  border: 0 !important;
}*/
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot:hover {
    border: none !important;
    border-radius: 37px !important;
    background: white !important;
    font-size: 14px;
    width: 90vw;
}
>>>.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
    border: 0 !important;
    border-radius: 37px !important;
    background: white !important;
    font-size: 14px;
    width: 90vw;
    box-shadow: none !important;
}
/*  >>>.v-badge--bottom .v-badge__badge {
    bottom: -4px !important;
}
>>>.v-badge__badge {
  height: 10px !important;
  width: 10px !important;
  right: -15px !important;
}*/


>>>.v-badge--bottom .v-badge__badge {
  border: #2562af 2px solid !important;
  bottom: -6px !important;
}
>>>.v-badge__badge {
  height: 14px !important;
  width: 14px !important;
  right: -16px !important;
}

>>>.v-dialog {
  border-radius: 20px;
  margin: 0 !important; 
}
.btnmsgMore {
  border-radius: 10px;
    display: flex;
    justify-content: center;
    height: 50px;
    background: white !important;
    cursor: pointer;
}

>>>.v-menuable__content__active {
  width: 100% !important;
  box-shadow: none !important;
  background: transparent !important;
  left: 0 !important;
}
>>>.v-menu__content {
  border-radius: 6px !important;
  width: 100% !important;
}
>>>p {
  margin-bottom: 0 !important;
    word-break: break-all;
    white-space: normal;
}
>>>audio:focus {
    outline: none;
}
>>>video:focus {
    outline: none;
}
.wrap{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.textDownload {
  font-size: 10px;
  text-align: right;
  cursor: pointer;
  margin-top: 10px;

}
.textDownload:hover {
    background: #0e345a5c;
    padding: 5px;
    border-radius: 20px;
}


.message.own .content .border_website {
  border-left: #c2e0ffb5 2px solid;
  padding-left: 5px;
}
.message.own .content .description_website {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  color: #bad2f1;
}
.message.own .content .title_website {
  margin: 0 !important;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  color: white !important;
}
.message.own .content .img_website {
  max-height: 100%;
  max-width: 85%;
  margin: auto;
}
.message.own .content .centerimg_website {
  justify-content: center;
  display: flex;
}

>>>.message.own .content a {
  color: #c2e0ffb5 !important;
}



.chat-container .content .border_website {
  border-left: #153c6d 2px solid;
  padding-left: 5px;
}
.chat-container .content .description_website {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  color: #153c6d91;
}
.chat-container .content .title_website {
  margin: 0 !important;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  color: #153c6d;
}
.chat-container .content .img_website {
  max-height: 100%;
  max-width: 85%;
  margin: auto;
}
.chat-container .content .centerimg_website {
  justify-content: center;
  display: flex;
}
.cancelGroup {
  box-shadow: none !important;
}
.acceptGroup {
  box-shadow: none !important;
  background: #2562af !important;
    color: white !important;
}
.systemMSG {
  padding: 5px;
  border-radius: 20px;
  background: #e8e8e875;
  font-size: 10px;
  color: #808080b8;
  width: 50%;
  display: flex;
  justify-content: center;
  text-align: center !important;
  margin: auto;
}
.systemDateNonMGT {
  padding: 3px;
  border-radius: 20px;
  background: #e8e8e875;
  font-size: 10px;
  color: #808080b8;
  width: max-content;
  display: flex;
  justify-content: center;
  text-align: center !important;
  margin: auto;
    margin-bottom: 5px;
}
.systemDate {
  padding: 3px;
  border-radius: 20px;
  background: #e8e8e875;
  font-size: 10px;
  color: #808080b8;
  width: max-content;
  display: flex;
  justify-content: center;
  text-align: center !important;
  margin: auto;
  margin-top: 30px;
    margin-bottom: 5px;
}

.systemMSG2 {
  border-radius: 10px;
  background: #e8e8e875;
  font-size: 10px;
  color: #808080b8;
  max-width: 50%;
  margin: auto;
}


.sidebar-menu {
  margin: 0;
  padding: 0;
}

.sidebar-menu ul {
  margin: 0;
  padding: 5px;
}

.sidebar-menu li {
  text-align: center;
  /*width: 32.8%;*/
  width: 20%;
  margin-bottom: 3px !important;
  /*background-color: #b4d2f5;*/
  /*border: 1px solid #eee;*/
  display: inline-block;
  padding: 0;
}

.sidebar-menu i {
  display: block;
  margin: 0 auto 10px auto;
  width: 32px;
  height: 32px;
  margin: 10px auto 0;
  line-height: 32px;
  text-align: center;
  font-size: 20px;
  color: #444444;
  margin-top: 0;
  /*padding-top: 5px;*/
}

.sidebar-menu a {
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  padding: 0;
  font-size: 13px !important;
  /*border: #2662af solid 1px;*/
  /*background-color: #b4d2f5;*/
  border-radius: 10px;
}

.sidebar-menu a span {
  color: #fdfdfd;
  /*font-size: 10px !important;*/
  padding: 5px 0 10px 0;
  display: block;
  text-transform: uppercase;
  /*font-family:'Josefin Sans';*/
  letter-spacing: 1px;
}
.sidebar-menu a:hover span {
  color: #27303e;
}

.sidebar-menu a:hover i {
  color: #2562ae;
}

.sidebar-menu a:hover {
  font-size: 13px !important;
  background: #ededed;
}


.sidebar-menu li:hover {
  /*width: 25%;*/
}


>>>ul {
    float: inline-start !important;
        list-style: none !important;
}

.menuContext {
  z-index: 1500;
    position: absolute !important;
    height: auto;
    width: auto;
    padding: 5px;
    margin: auto;
        border: none !important;
    border-radius: 5px;
    background-color: #0b4277;
    color: white !important;
    font-weight: normal;
    white-space: nowrap;
}


.menuContext:focus {
  border: none !important;
   outline: none;
}
.menuContext:hover {
    cursor: pointer;
}
.MenuRightSelect {
  cursor:pointer;
  padding: 3px !important;
  margin-right: 10px !important;
}
.Last {
  margin-right: 0px !important;
}
.MenuRightSelect:hover {
  background: #73737336 !important;
  border-radius: 3px !important;
}

.MenuStyle {
  background: #2562af !important;
  padding: 10px;
  cursor: pointer;
  width: 100%;
}

.iconMenuHeader {
  font-size: 24px;
  color: #7dc6ff69;
}
>>>.iconMenuHeaderSelected {
  font-size: 24px;
  color: white !important;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}
>>>.v-list--two-line.v-list--dense .v-list__tile {
    height: auto !important;
}
.image-upload>input {
  display: none;
}
.image-upload {
      display: inline-block;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
    height: 40vw;
}
.imageProfile {
  height: 40vw;
  width: 40vw;
  border-radius: 20px;
  cursor: pointer !important;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.profileBG {
  margin-right: 5px;
  height: 35px !important;
  width: 35px !important;
  background: white !important;
  color: #2562af;
}
.profileBG_White {
  margin-right: 5px;
  height: 35px !important;
  width: 35px !important;
  background: #2562af !important;
  color: white !important;
  cursor: pointer;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}

.HeadersDetail {
  margin-bottom: 0 !important;
  color: #5b8cbd8c;
  font-size: 11px; 
}
.Detail {
  color: #5b8cbd;
  font-size: 16px;
}
.detailBG {
      padding: 10px 10px;
    padding-top: 10px;
  cursor: pointer;
}
.detailBG:hover {
  background: #2196f312;
}

.showmentionCSS {
  background: #1b232d63 !important;
  margin: 0 !important;
  bottom: 75px !important;
  position: fixed !important;
  width: 100% !important;
  height: 55px !important;
  padding: 5px !important;
}

.modalc {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw; /* Full width */
  height: 100vh; /* Full height */
  /*overflow: auto;  Enable scroll if needed */
  overflow: hidden;
 /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}
/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  /*width: 80%;*/
  /*width: auto;
  height: 50%;*/
  max-width: 95%;
  max-height: 80%;
}

#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}
#headcaption {
  /*margin: auto;
  display: block;
  text-align: left;
  color: white;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;*/
  margin: auto;
  display: block;
  text-align: left;
  color: #fff;
  padding-top: 1vh;
  padding-bottom: 1vh;
  background-color: #1b232d;
}

>>>.container {
    padding: 0px !important;
}
.btnSave {
  color: white !important;
  background: #2562af !important;
  box-shadow: none !important;
  margin: 20px auto !important;
  display: flex !important;
}

>>>.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea {
    margin-top: 0px !important;
    resize: none;
}

</style>


// WEBPACK FOOTER //
// src/components/mail/ListChat.vue